<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'SuperDash'
}
</script>

<style lang="css" scoped>

</style>